module.exports = __webpack_public_path__ + "ico_Asig_Atq.png";